/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
// import 'core-js/es6/symbol';
// import 'core-js/es6/object';
// import 'core-js/es6/function';
// import 'core-js/es6/parse-int';
// import 'core-js/es6/parse-float';
// import 'core-js/es6/number';
// import 'core-js/es6/math';
// import 'core-js/es6/string';
// import 'core-js/es6/date';
// import 'core-js/es6/array';
// import 'core-js/es6/regexp';
// import 'core-js/es6/map';
// import 'core-js/es6/set';

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.

declare global {
    interface Date {
        toISO8601String(): string;
        getTimezoneOffset(): number;
    }
}

Date.prototype.toISO8601String = function() {
    const padDigits = (number: number|string, digits: number) => {
        return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number;
    };
    const offsetMinutes = this.getTimezoneOffset();
    const offsetHours = Math.round(offsetMinutes / 60);
    let offset = 'Z';
    if (offsetHours !== 0) {
        offset = (offsetHours < 0 ? '+' : '-') + padDigits(Math.abs(offsetHours), 2);
        offset += ':' + padDigits(Math.abs(Math.round(offsetMinutes % 60)), 2);
    }

    return this.getFullYear()
        + '-' + padDigits((this.getMonth() + 1), 2)
        + '-' + padDigits(this.getDate(), 2)
        + 'T'
        + padDigits(this.getHours(), 2)
        + ':' + padDigits(this.getMinutes(), 2)
        + offset;
};

(window as any).global = window;
